import { useCallback } from 'react';
import useAjaxRequest from './useAjaxRequest';
import { URL_LGPD_CONSENT } from '../config/endpoints';
import { lgpdConsentBody } from '../utils/lgpdConsentBody';
import env from '../config/environment';

const useLgpdConsent = () => {
  const {
    response: { error, loading, data: lgpdResponse },
    performRequest,
  } = useAjaxRequest();

  const getLgpdConsent = useCallback(
    (businessProcess, subprocess, cpf) =>
      performRequest({
        method: 'get',
        url: URL_LGPD_CONSENT(businessProcess, cpf),
        params: {
          'macro-processo-negocio': env.MACRO_PROCESS_CODE,
          'sub-processo-negocio': subprocess,
        },
      }),
    [performRequest]
  );

  const postLgpdConsent = useCallback(
    (businessProcess, cpf, propsalId, lgpdConsent, subprocess) =>
      performRequest({
        method: 'post',
        url: URL_LGPD_CONSENT(businessProcess, cpf),
        data: lgpdConsentBody(propsalId, cpf, subprocess, lgpdConsent),
      }),
    [performRequest]
  );

  return { error, loading, lgpdResponse, getLgpdConsent, postLgpdConsent };
};

export default useLgpdConsent;
